module.exports = __webpack_public_path__ + "img/对公转账支付.57a8ac9a.png";